import React from 'react';
import {withRouter} from "react-router-dom";

class Help extends React.Component {
    render() {
        return (
            <div className="right-col" role="main">
                <div className="x-panel">
                    <div className="x-title">
                        <h2>Nápověda</h2>
                        <div className="clearfix"/>
                    </div>
                    <div className="x-content">
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Help);



/** WEBPACK FOOTER **
 ** ./src/containers/Help/index.js
 **/